import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import {AuthnStart} from "../user/UserActions";
import queryString from "query-string";
import {useLocation} from "react-router-dom";

export default function SignIn() {

    const dispatch = useDispatch();
    const location = useLocation();


    useEffect(() => {
        console.log(location);
        if (location.search) {
            const params = queryString.parse(location.search);
            console.log("AuthWorker: ", params);
            localStorage.setItem("mttmsl",String(params.mttmsl));
            localStorage.setItem("mttmst",String(params.mttmst));
            dispatch(AuthnStart(params.email, params.mttms));
        }
    },[]);





    return(
        <>
        </>
    );

}
